// src/pages/Matriculas/components/InfoRecinto.jsx
import React from 'react';
import { Card, Radio, Space, Tag, Empty } from 'antd';
import { 
  EnvironmentOutlined, 
  DollarOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';

export default function InfoRecinto({ recintos, recintoSeleccionado, onSeleccionar }) {
  const formatearMoneda = (monto) => {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0
    }).format(monto || 0);
  };

  const getVigenciaTexto = (config) => {
    if (config.tipoVigencia === 'anual') {
      return '1 año';
    } else if (config.tipoVigencia === 'meses' && config.mesesVigencia) {
      return `${config.mesesVigencia} meses`;
    }
    return 'Indefinida';
  };

  if (recintos.length === 0) {
    return (
      <Card>
        <Empty
          description="No hay recintos con matrícula configurada"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </Card>
    );
  }

  return (
    <Card title="Selecciona el recinto">
      <p className="text-gray-600 mb-4">
        Elige el recinto donde deseas adquirir la matrícula
      </p>

      <Radio.Group
        value={recintoSeleccionado?._id}
        onChange={(e) => {
          const recinto = recintos.find(r => r._id === e.target.value);
          onSeleccionar(recinto);
        }}
        className="w-full"
      >
        <Space direction="vertical" className="w-full" size="middle">
          {recintos.map((recinto) => (
            <Card
              key={recinto._id}
              hoverable
              className={`cursor-pointer transition-all ${
                recintoSeleccionado?._id === recinto._id
                  ? 'border-blue-500 border-2 shadow-lg'
                  : 'border-gray-200'
              }`}
              onClick={() => onSeleccionar(recinto)}
            >
              <Radio value={recinto._id} className="w-full">
                <div className="flex items-start justify-between ml-2">
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold mb-2 flex items-center gap-2">
                      <EnvironmentOutlined className="text-blue-500" />
                      {recinto.nombre}
                    </h3>

                    {recinto.direccion && (
                      <p className="text-sm text-gray-600 mb-3">
                        {recinto.direccion}
                      </p>
                    )}

                    {recinto.configuracionMatricula?.descripcion && (
                      <p className="text-sm text-gray-700 mb-3">
                        {recinto.configuracionMatricula.descripcion}
                      </p>
                    )}

                    <div className="flex flex-wrap gap-3">
                      <Tag
                        icon={<DollarOutlined />}
                        color="blue"
                        className="text-base px-3 py-1"
                      >
                        {formatearMoneda(recinto.configuracionMatricula?.valorMatricula)}
                      </Tag>

                      <Tag
                        icon={<ClockCircleOutlined />}
                        color="blue"
                        className="px-3 py-1"
                      >
                        Vigencia: {getVigenciaTexto(recinto.configuracionMatricula)}
                      </Tag>

                      {recinto.configuracionMatricula?.activa && (
                        <Tag
                          icon={<CheckCircleOutlined />}
                          color="blue"
                          className="px-3 py-1"
                        >
                          Activa
                        </Tag>
                      )}
                    </div>
                  </div>
                </div>
              </Radio>
            </Card>
          ))}
        </Space>
      </Radio.Group>
    </Card>
  );
}
